import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts/LanguageContext';
import { useCart } from '../../contexts/CartContext';
import ProductGrid from '../../components/ProductGrid';
import './Home.css';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../features/store';
import HomeHero from './HomeHero';
import { getAllProducts, selectAllProducts } from '../../features/products';
import { Product, ProductCategory } from '../../features/products/productModels';
import { getAllCategories, selectAllCategories } from '../../features/categories';

const Home: React.FC = () => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();
  const dispatch: AppDispatch = useDispatch();
  const { addToCart } = useCart();
  const [wishlistItems, setWishlistItems] = useState<string[]>([]);
  const allProducts = useSelector(selectAllProducts);
  const categories = useSelector(selectAllCategories);
  const bannerUrl =
    'https://www.shutterstock.com/image-vector/sport-nutrition-protein-whey-supplement-260nw-1415399246.jpg';

  useEffect(() => {
    dispatch(getAllProducts());
    dispatch(getAllCategories());
  }, [dispatch]);

  const handleAddToCart = (product: Product) => {
    // addToCart(product, 1);
  };

  const handleToggleWishlist = (productId: number) => {
    const id = productId.toString();
    setWishlistItems(prev => 
      prev.includes(id) 
        ? prev.filter(existingId => existingId !== id)
        : [...prev, id]
    );
  };

  const isCategoryObject = (category: Product['categoryId']): category is ProductCategory => {
    return typeof category === 'object' && category !== null && '_id' in category;
  };

  const getProductsForCategory = (categoryId: string) => {
    return allProducts.filter((product: Product) => {
      if (!product.categoryId) {
        return false;
      }

      if (typeof product.categoryId === 'string') {
        return product.categoryId === categoryId;
      }

      if (isCategoryObject(product.categoryId)) {
        return product.categoryId._id === categoryId;
      }

      return false;
    });
  };

  const topCategories = categories;

  return (
    <div className={`home-page ${isRTL ? 'rtl' : 'ltr'}`}>
      {/* Hero Section */}
      <HomeHero />

      {/* Features Section */}
      {/* <FetauersSections />   */}

      {/* Featured Products */}
      <div className="products-section sale-section">
        <div className="container">
        <div className="category-section-header">
           <h3 className="category-section-title">{t('featuredProductsTitle')}</h3>
           <div className="category-section-accent" />
           
          </div>
          <ProductGrid
            products={allProducts}
            onAddToCart={handleAddToCart}
            onToggleWishlist={handleToggleWishlist}
            wishlistItems={wishlistItems}
            showFilters={false}
          />
        </div>
      </div>

      {/* Banner Section */}
      <section className="home-banner" aria-label={t('home.seasonalPromotion')}>
        <img
          src={bannerUrl}
          alt={t('home.seasonalPromotionBanner')}
          className="home-banner-image"
        />
      </section>

      {/* Category Sections */}
      {topCategories.map((category) => {
        const categoryProducts = getProductsForCategory(category._id);

        if (!categoryProducts.length) {
          return null;
        }

        return (
          <section
            key={category._id}
            className="category-products-section"
            aria-label={`${category.categoryName} ${t('home.products')}`}
          >
            <div className="container">
              <div className="category-section-header">
                <h3 className="category-section-title">{category.categoryName}</h3>
                <div className="category-section-accent" />
              </div>
              <ProductGrid
                products={categoryProducts}
                onAddToCart={handleAddToCart}
                onToggleWishlist={handleToggleWishlist}
                wishlistItems={wishlistItems}
                showFilters={false}
              />
            </div>
          </section>
        );
      })}

    </div>
  );
};

export default Home;
